import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { formStyles } from '../ClaimCMS1500Form.styles';
import { ClaimTextField } from '../fields';

export const Box01a_InsuredId: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">1a. INSURED&apos;S I.D. NUMBER</Typography>
      <Controller
        name="insuredIdNumber"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            fullWidth
            variant="outlined"
            sx={formStyles.monospaceField}
          />
        )}
      />
    </>
  );
};